import "./App.css";
import AccordionCard from "./components/AccordionCard.js";

function App() {
  return <AccordionCard />;
}

export default App;
